module.exports = __webpack_public_path__ + "static/19_PLATOS-FRA-POTAUFEU-D.5ddf7860.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/19_PLATOS-FRA-POTAUFEU-D.png
// module id = 664
// module chunks = 35783957827783